import { createContext } from "react";

export const EvaluatorInputVariablesContext = createContext<string[] | null>(
  null
);
